import React from 'react';

import { Button } from '@mui/material';

import classes from './ResendCode.module.scss';
import { useTimer } from '../../../../hooks/useTimer';

type ResendCodeProps = {
  nextVerificationCodeCallEpoch: number | undefined | null;
  onResendCodeClick: () => void;
};

const ResendCode = ({
  nextVerificationCodeCallEpoch,
  onResendCodeClick,
}: ResendCodeProps) => {
  const { minutes, seconds, isTimeOver } = useTimer(nextVerificationCodeCallEpoch || 0);

  return (
    <div className={classes.resendButtonContainer}>
      <Button disabled={!isTimeOver} variant="text" onClick={onResendCodeClick}>
        Resend Code
      </Button>
      {!isTimeOver && !!nextVerificationCodeCallEpoch && (
        <p className={classes.timer}>
          ({minutes}:{seconds})
        </p>
      )}
    </div>
  );
};

export { ResendCode };
